import { TRatiosCarterasDBModel } from "../types/CarteraRatioTypes"

export type TDataSeries = [number, number]

type TMapRatiosToGraphProps = {
    ratios: TRatiosCarterasDBModel[];
}

export const MapRatiosToGraph = ({ ratios }: TMapRatiosToGraphProps): TDataSeries[] => {
    let dataRatios: TDataSeries[] = [];
    ratios.forEach((row: TRatiosCarterasDBModel) => {
        const dateFormated = new Date(row.dateCalculation).getTime()    
        
        let value: number = row.valueCartera;
        if (row.ratio === 'linear_return' || row.ratio === 'volatility' || row.ratio === 'max_drawdown' || row.ratio === 'downside_deviation') {
            value = row.valueCartera * 100;
        };

        dataRatios.push([ dateFormated, value ])
    });
    return dataRatios
}

